import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-dark py-8 px-6" data-id="element-43">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-44">
          <div className="flex items-center gap-6" data-id="element-45">
            <button onClick={() => setShowPrivacy(true)} className="text-gray-400 hover:text-gold text-sm transition-colors underline-offset-4 hover:underline" data-id="element-46">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-47">•</span>
            <button onClick={() => setShowTerms(true)} className="text-gray-400 hover:text-gold text-sm transition-colors underline-offset-4 hover:underline" data-id="element-48">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-gray-500 text-xs" data-id="element-49">
            © {new Date().getFullYear()} El Pasaporte Financiero. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-50">
        <p className="font-bold text-dark" data-id="element-51">Última actualización: Abril 2026</p>

        <p data-id="element-52">
          En El Pasaporte Financiero, respetamos tu privacidad y nos
          comprometemos a proteger tu información personal. Esta política
          describe cómo recopilamos, usamos y protegemos tus datos.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-53">
          1. Información que recopilamos
        </h3>
        <p data-id="element-54">
          Al realizar tu compra, recopilamos únicamente la información necesaria
          para procesar tu transacción: nombre, dirección de correo electrónico
          y datos de pago. Los datos de pago son procesados de forma segura por
          nuestro proveedor de pagos y nunca son almacenados en nuestros
          servidores.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-55">
          2. Uso de la información
        </h3>
        <p data-id="element-56">
          Tu información se utiliza exclusivamente para: procesar tu compra y
          entregarte el producto digital, enviarte el enlace de descarga, y
          comunicarnos contigo en caso de ser necesario respecto a tu compra.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-57">
          3. Protección de datos
        </h3>
        <p data-id="element-58">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal. Utilizamos cifrado SSL para todas
          las transacciones y no compartimos, vendemos ni alquilamos tu
          información personal a terceros.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-59">4. Cookies</h3>
        <p data-id="element-60">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y analizar el tráfico del sitio. Puedes configurar tu
          navegador para rechazar cookies si lo prefieres.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-61">5. Tus derechos</h3>
        <p data-id="element-62">
          Tienes derecho a solicitar acceso, corrección o eliminación de tus
          datos personales en cualquier momento. También puedes solicitar que
          dejemos de enviarte comunicaciones.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-63">
          6. Cambios a esta política
        </h3>
        <p data-id="element-64">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Los cambios serán publicados en esta página con la
          fecha de actualización correspondiente.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-65">
        <p className="font-bold text-dark" data-id="element-66">Última actualización: Abril 2026</p>

        <p data-id="element-67">
          Al comprar y descargar El Pasaporte Financiero, aceptas los siguientes
          términos y condiciones. Por favor, léelos cuidadosamente antes de
          realizar tu compra.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-68">
          1. Producto digital
        </h3>
        <p data-id="element-69">
          El Pasaporte Financiero es un producto digital en formato PDF. Al
          completar tu compra, recibirás acceso inmediato para descargar el
          archivo. Este es un pago único; no hay suscripciones ni cargos
          recurrentes.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-70">2. Uso personal</h3>
        <p data-id="element-71">
          El contenido de este manual es para tu uso personal únicamente. Queda
          prohibida la reproducción, distribución, reventa o compartición del
          material sin autorización expresa por escrito.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-72">
          3. Descargo de responsabilidad
        </h3>
        <p data-id="element-73">
          El Pasaporte Financiero es un recurso educativo e informativo. No
          constituye asesoría legal, financiera ni crediticia profesional. Los
          resultados pueden variar según la situación individual de cada
          persona. Te recomendamos consultar con un profesional calificado para
          decisiones financieras importantes.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-74">
          4. Garantía de devolución
        </h3>
        <p data-id="element-75">
          Ofrecemos una garantía de devolución de 30 días. Si envías las cartas
          de disputa incluidas en el manual y no recibes ninguna respuesta de
          los Bureaus de crédito confirmando la recepción de tu disputa dentro
          de los 30 días posteriores al envío, te reembolsaremos el monto total
          de tu compra ($16 USD). Para solicitar un reembolso, deberás
          proporcionar evidencia del envío de las cartas por correo certificado.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-76">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-77">
          Todo el contenido del manual, incluyendo textos, plantillas de cartas,
          estrategias y metodologías, está protegido por derechos de autor. El
          uso no autorizado puede resultar en acciones legales.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-78">
          6. Limitación de responsabilidad
        </h3>
        <p data-id="element-79">
          No nos hacemos responsables por los resultados obtenidos al aplicar
          las estrategias descritas en el manual. El crédito de cada persona es
          único y los resultados dependen de múltiples factores individuales.
        </p>

        <h3 className="font-bold text-dark text-base mt-2" data-id="element-80">
          7. Modificaciones
        </h3>
        <p data-id="element-81">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación en esta página.
        </p>
      </Modal>
    </>;
}